import { useState, type ReactNode } from 'react';

import { ChevronDownIcon, ChevronRightIcon } from '@/components/icons';

/**
 * Seção avançada colapsável (CO-3 — auditoria Compras 2026-06-23).
 *
 * Fechada por padrão, com um resumo na linha fechada (ex.: "Realizado ·
 * lançado", "Logística · entregue · 30/07"). Abre sob demanda pelo chevron.
 * Usada no card de item da cotação pra esconder as seções avançadas
 * (faturamento direto / realizado / logística) que faziam a "parede" densa.
 */
export function CollapsibleSection({
  title,
  summary,
  children,
  testId,
}: {
  title: string;
  summary?: string | null;
  children: ReactNode;
  testId?: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <div className="mt-3 pt-3 border-t border-line dark:border-line-dark" data-testid={testId}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 w-full text-left"
        aria-expanded={open}
      >
        {open ? (
          <ChevronDownIcon className="w-4 h-4 text-ink-3 dark:text-ink-dark-3 shrink-0" />
        ) : (
          <ChevronRightIcon className="w-4 h-4 text-ink-3 dark:text-ink-dark-3 shrink-0" />
        )}
        <span className="text-sm font-medium text-ink-1 dark:text-ink-dark-1">{title}</span>
        {!open && summary && (
          <span className="text-xs text-ink-3 dark:text-ink-dark-3 ml-auto truncate">{summary}</span>
        )}
      </button>
      {open && <div className="mt-3">{children}</div>}
    </div>
  );
}
